import React, { Component } from "react";
import { Form, Icon, Input, Checkbox } from "antd";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import authActions from "../../actions/auth";
import messages from "./messages";
import Wrapper from "../LandingBlockWrapper/BlockWrapper";
import Button from "../Button/index";

const FormItem = Form.Item;

class LogInForm extends Component{
	constructor(props) {
		super(props);
		this.state = {
			submitted: false
		};
	}
	
	// handleSignUp = (e) => {
	// 	e.preventDefault();
	// 	this.props.form.validateFields((err, values) => {
	// 		if (!err) {
	// 			authActions.userCreateWithEmailAndPass(values);
	// 		}
	// 	});
	//
	// };
	
	handleSignIn = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				authActions.signInWithEmailAndPassword(values);
			}
		});
	};
	
	render() {
		const { form: { getFieldDecorator }, formatMessage } = this.props;
		return (
			<Form className="login-form">
				<FormItem>
					{getFieldDecorator("email", {
						rules: [
							{
								type: "email",
								required: true,
								message: formatMessage(messages.emailInValid)
							},
							{
								message: formatMessage(messages.email)
							}
						]
					})(
						<Input
							prefix={<Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }}/>}
							placeholder={formatMessage(messages.placeholder)}/>
					)}
				</FormItem>
				<FormItem>
					{getFieldDecorator("password", {
						rules: [
							{ required: true, message: formatMessage(messages.password) },
						],
					})(
						<Input prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }}/>} type="password"
						       placeholder={formatMessage(messages.passwordPlaceholder)}/>
					)}
				</FormItem>
				<FormItem>
					{getFieldDecorator("remember", {
						valuePropName: "checked",
						initialValue: true,
					})(
						<Checkbox>Remember me</Checkbox>
					)}
					<Link to="/password_reset">
						<div className="login-form-forgot">Forgot password</div>
					</Link>
					<Button
						type="primary"
						onClick={this.handleSignIn}
					>
						Sign in
					</Button>
					{/*<Button*/}
					{/*type="primary"*/}
					{/*onClick={this.handleSignUp}*/}
					{/*>*/}
					{/*Sign Up*/}
					{/*</Button>*/}
				</FormItem>
			</Form>
		);
	}
}

class LogIn extends Component{
	render() {
		const { form, auth, intl: { formatMessage } } = this.props;
		return <div>
			<LogInForm form={form} auth={auth} formatMessage={formatMessage}/>
		</div>;
	}
}

const mapStateToProps = ({ user: { auth } }) => {
	return { auth };
};

const LogInPage = connect(mapStateToProps)(Form.create()(injectIntl(LogIn)));

export default () => {
	return <Wrapper className="LogIn">
		<LogInPage/>
	</Wrapper>;
};









// WEBPACK FOOTER //
// ./src/components/LogIn/LogIn.js